import React from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { Text, Flex } from '@ui/wrapper';

const FIXED_COL_WIDTH = '200px';

const Block = styled(Flex)`
  flex-direction: column;
  width: ${({ wide }) =>
    !wide
      ? FIXED_COL_WIDTH
      : null}; /* it must be fixed width to match designs */
  margin-bottom: ${({ collapseBottom }) =>
    collapseBottom ? 0 : themeGet('space.5')};
  margin-right: ${({ wide }) => (wide ? 0 : themeGet('space.5'))};
`;

const WrapperText = styled(Text)`
  min-width: 0;
`;

type ContentBlockProps = {
  children: React.ReactNode;
  title: string;
  wide?: boolean;
  collapseBottom?: boolean;
} & Pick<React.CSSProperties, 'flexDirection'>;

/**
 * Just wrapping a Flex item to export as a required
 * wrapper around your ContentBlocks WHEN disaplying them
 * as COLUMNS. Exporting altogether results in a better API
 */
const GroupColumnBlocks = Flex;

/**
 * @usage
 * <GroupColumnBlocks>
 *   <ContentBlock></ContentBlock>
 * </GroupColumnBlocks>
 */
const ContentBlock = ({
  children,
  title,
  wide = false,
  collapseBottom = false,
  ...rest
}: ContentBlockProps) => (
  <Block
    data-testid="block"
    {...{
      wide,
      collapseBottom,
      ...rest,
    }}
  >
    <Flex>
      <WrapperText bold>{title}</WrapperText>
    </Flex>
    <Flex>{children}</Flex>
  </Block>
);

export { ContentBlock, GroupColumnBlocks };
